import { useQuery } from '@tanstack/react-query';
import { kpiApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';

interface UseBudgetFiscalYearStatusOptions {
  /**
   * 判定基準日を上書き（YYYY-MM-DD, JST）。デバッグ用。FY 切替前後の表示確認に使用する。
   * 通常は省略してサーバの現在時刻を使う。
   */
  now?: string;
  /**
   * availableFiscalYears を強制上書き（FY 番号カンマ区切り）。
   * Sheets credentials が無いローカル開発で警告 UI を確認するためのデバッグ用。
   */
  mockFiscalYears?: string;
}

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business fibo予算スプレッドシートのFY切替状況をTanStack Query経由で取得。次FYシート作成状況とseverity（none/warning/critical）を返し、KPIダッシュボード下部の警告バナー表示に利用
 * @graph-connects /kpi/budget-fiscal-year-status [calls] fibo予算 FY切替状況API呼び出し
 * @graph-connects kpiApi.getBudgetFiscalYearStatus [calls] APIクライアント呼び出し
 * @graph-connects queryKeys [calls] TanStack Queryキー生成
 */
export function useBudgetFiscalYearStatus(options?: UseBudgetFiscalYearStatusOptions) {
  return useQuery({
    queryKey: queryKeys.kpi.budgetFiscalYearStatus({
      now: options?.now,
      mockFiscalYears: options?.mockFiscalYears,
    }),
    queryFn: () =>
      kpiApi.getBudgetFiscalYearStatus({
        now: options?.now,
        mockFiscalYears: options?.mockFiscalYears,
      }),
    // FY 切替判定は日付ベースで日単位の精度で十分。5 分 staleTime で十分に頻繁な再評価
    staleTime: 5 * 60 * 1000,
  });
}
